let activeGameAudio: HTMLAudioElement | null = null;

export function gameVoiceUrl(clip: string) {
  return `/assets/audio/games/lumi-v1/${clip}.mp3`;
}

export function playGameVoice(clip: string) {
  activeGameAudio?.pause();
  const audio = new Audio(gameVoiceUrl(clip));
  activeGameAudio = audio;
  audio.addEventListener("ended", () => {
    if (activeGameAudio === audio) activeGameAudio = null;
  }, { once: true });
  return audio.play().catch(() => undefined);
}

export function stopGameVoice() {
  activeGameAudio?.pause();
  activeGameAudio = null;
}